import { IRequest } from '@r1-frontend/shared/types/IRequest';

export type { ISatellitesList } from './dto/ResponseDto';
export type { ICitySatellite } from './dto/ResponseDto';

/*
* Получение информации по всем городам, сателлитам и их регионов. Список используется в поиске по городам на сайте.
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/3597d89d651dcd12f887bacf97bec079
*/

export const getCitiesSatellites = (providerId: number): IRequest => ({
    uri: '/v1/geography/get-cities-satellites',
    method: 'GET',
    headers: { 'ProviderId': `${providerId}` },
});
